/**
 * Language Helper Utilities
 * Helper functions and constants derived from the centralized LANGUAGES list
 */

import { LANGUAGES } from './languageConstants';

export const SOURCE_LANGUAGE_CODE = LANGUAGES[0]?.value || 'en-US';

export const LANGUAGE_LABELS = LANGUAGES.reduce((acc, lang) => {
  acc[lang.value] = lang.label;
  return acc;
}, {});

/**
 * Get language label by code - case-insensitive lookup
 */
export const getLanguageLabel = (code) => {
  if (!code) return code;
  const lang = LANGUAGES.find((l) => l.value?.toLowerCase() === code?.toLowerCase());
  return lang?.label || code;
};
